export default {
  'liked_trials': 'Liked Trials',
  'no_liked_trials': 'You have not liked any trials yet.',
  'status': 'Status',
  'trial_name': 'Trial Name',
  'trial_objective': 'Objective',
  'type': 'Type',
  'unlike_trial': 'Unlike Trial',
};
